import debounce from 'lodash/debounce';
import domReady from '../helpers/dom-ready';

class ExhibitionTopSpacing {
  static init() {
    return new ExhibitionTopSpacing();
  }

  constructor() {
    this.exhibitionBody = document.querySelector('body.single-exhibition');
    if (!this.exhibitionBody) { return; }
    this.breadcrumbs = document.querySelector('.breadcrumbs');
    if (!this.breadcrumbs) { return; }

    this.updateCssVariable();

    window.addEventListener('resize', debounce(() => { this.updateCssVariable(); }, 50));
  }

  updateCssVariable() {
    if (window.innerWidth > 768) { return; }
    const height = this.breadcrumbs.offsetHeight;
    this.exhibitionBody.style.setProperty('--exhibition-first-child-top-spacing', `${height + 120}px`);
  }
}

domReady(() => {
  ExhibitionTopSpacing.init();
});
